<template>
    <v-container>
      <v-row>
          <v-col cols="12">
            <div class="text-left" style="margin-bottom:20px;">
                <router-link to="/archive">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                </router-link>
              </div>                  
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h1>Las Vegas</h1>
        </v-col>
      </v-row>
      


      <div class="text-left">12:47pm Las Vegas Airpot Limo to Palazzo 26th December</div>
      <v-row style="margin-top:10px;">
        <v-col cols="12" class="text-left">
          <a href="https://www.eiffeltowerrestaurant.com/" target="_blank">

              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-top:-20px;margin-bottom:15px;"
              >
                Eiffel Tower Restaurant 26th December
              </v-btn>
          </a>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            <a href="https://www.caesars.com/paris-las-vegas/restaurants/vanderpump-a-paris" target="_blank">
              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-top:-20px;"
              >
                Vanderpump à Paris 26th December
              </v-btn>
            </a>
          </div>
        </v-col>
      </v-row>
      <v-row style="margin-top:10px;">
        <v-col cols="12" class="text-left">
          <a href="https://www.thesphere.com/shows/wizard-of-oz-experience" target="_blank">

              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-bottom:15px;"
              >
                Sphere - Wizard of Oz December 27 1PM
              </v-btn>
          </a>
        </v-col>
        <v-col cols="12">
          <video autoplay="" loop="" playsinline="" poster="" disableremoteplayback=""><source src="https://us-east-1-msg.graphassets.com/ALB6wy2xYSoCFY4hrWCvsz/cmc4wqght0njr07lnczs5q1hf" type="video/mp4"></video>            
        </v-col>
      </v-row>      
      <div class="text-left">5:00pm Palazzo to Las Vegas Airpot Limo 29th December</div>
      <div class="text-left">December 29th - Las Vegas to Sydney (Arrive Sydney December 31st)</div>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {

    }
  }
  </script>